<script>
import axios from "axios";
import moment from "moment";

import TitlePage from "../../components/layout/TitlePage.vue";
import ModalFormEditStatusAforo from "../../components/modals/ModalFormEditStatusAforo.vue";

import { getVariant } from "../../helpers/badgeLookupTable";
import { downloadBlob } from "../../helpers/download";
import ModalFormDeleteAforo from "../../components/modals/ModalFormDeleteAforo.vue";
import TIPO_INSPECCION from "../../constants/TiposInspeccion";
import aforosService from "../../services/aforos.service.js";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    TitlePage,
    ModalFormEditStatusAforo,
    ModalFormDeleteAforo,
  },
  computed: {
    ...mapGetters({
      filtro: "filtros/filtro",
      fecha: "filtros/filtro",
    }),

    TIPO_INSPECCION() {
      return TIPO_INSPECCION;
    },
  },
  data() {
    return {
      fetchIsPending: undefined,
      fetchIsSuccess: undefined,
      fetchIsError: undefined,
      aforos: undefined,

      showEditStatus: false,
      pageMeta: undefined,

      filter: undefined, // { tipo_inspeccion_id , estado }

      selectedAforo: undefined,

      showDeleteModal: false,

      exportIsPending: false,

      fields: [
        { key: "codigo", label: "N° Despacho" },
        { key: "cliente", label: "Cliente" },
        { key: "aduana", label: "Aduana" },
        { key: "fecha_inspeccion", label: "Fecha de inspección" },
        { key: "codigo_agente", label: "Código Agente" },
        { key: "tipo_inspeccion", label: "Tipo" },
        { key: "numero_sello", label: "Número de sello"},
        { key: "estado", label: "Estado" },
        { key: "acciones", label: "Acciones" },
      ],
    };
  },
  methods: {
    ...mapActions({
      cambiarFiltro: "filtros/cambiarFiltro",
    }),
    async fetch() {
      this.fetchIsPending = true;
      try {
        let query = {
          params: {
            page: this.pageMeta?.current_page || 1,
            estado: this.filter?.estado,
            tipo_inspeccion_id: this.filter?.tipo_inspeccion_id,
          },
        };

        if (this.$route.query.dashboardFilter) {
          query.params.page = this.pageMeta?.current_page || 1;
          query.params.estado = `["${this.filtro.value}"]`;
        }

        const { data } = await axios.get("/api/admin/aforos", query);

        if (data?.data && data?.meta) {
          this.aforos = [...data.data];
          this.pageMeta = { ...data.meta };
        }
      } catch (e) {
        console.error(e);
        this.fetchIsError = true;
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al obtener el listado de aforos.",
        });
      }
      this.fetchIsError = false;
      this.fetchIsPending = false;
    },
    getVariant(status) {
      return getVariant(status);
    },
    async exportarExcel() {
      this.exportIsPending = true;
      try {
        const params = {
          estado: this.filter?.estado,
          tipo_inspeccion_id: this.filter?.tipo_inspeccion_id,
        };

        if (this.$route.query.dashboardFilter) {
          params.estado = `["${this.filtro.value}"]`;
        }

        const { data } = await aforosService.exportar(params);

        downloadBlob(data, `aforos_${moment().format("YYYY-MM-DD")}.xlsx`);
      } catch (e) {
        console.error(e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al exportar el listado de aforos.",
        });
      }
      this.exportIsPending = false;
    },
  },
  watch: {
    "pageMeta.current_page": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.fetch();
      }
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<template>
  <div class="flex flex-col gap-8">
    <title-page title="Aforos" />

    <div class="flex flex-col gap-4 bg-white shadow-md p-4">
      <div class="flex flex-row items-center justify-between gap-2">
        <h1 class="!text-xl !font-bold">Aforos</h1>
        <button
          type="button"
          class="btn-secundario"
          :disabled="exportIsPending"
          @click="exportarExcel"
        >
          <b-spinner v-if="exportIsPending" small></b-spinner>
          Reporte Aforos
        </button>
      </div>

      <div
        v-if="fetchIsPending"
        class="text-center mx-auto my-auto h-full text-[#ffce1e]"
      >
        <b-spinner class="align-middle"></b-spinner>
        <strong> Cargando...</strong>
      </div>

      <div v-else>
        <b-table
          class="text-left"
          hover
          show-empty
          responsive
          :items="aforos"
          :fields="fields"
        >
          <template #empty>
            <h4 class="text-center">No hay elementos en la lista</h4>
          </template>

          <template #cell(codigo)="row">
            <div class="flex flex-row text-sm items-center gap-2">
              <div
                class="h-6 w-[5px]"
                :class="[getVariant(row.item.estado)]"
              ></div>
              {{ row.item?.despacho?.despacho?.numero_despacho ?? "-" }}
            </div>
          </template>

          <template #cell(cliente)="row">
            {{ row.item?.despacho?.despacho?.cliente?.nombre ?? "-" }}
          </template>

          <template #cell(aduana)="row">
            {{ row.item?.aduana?.nombre ?? "-" }}
          </template>


          <template #cell(fecha_inspeccion)="row">
            {{ row.item?.inspectable?.fecha_inspeccion ?? "-" }}
          </template>

          <!-- <template #cell(fecha_notificacion)="row">
            {{ row.item?.tipo_inspeccion?.id == TIPO_INSPECCION.SIN_AFORO ? "-" : (row.item?.fecha_notificacion ?? "-") }}
          </template> -->

          <template #cell(codigo_agente)="row">
            {{ row.item?.despacho?.despacho?.agente?.nombre ?? "-" }}
          </template>

          <template #cell(tipo_inspeccion)="row">
            {{ row.item?.tipo_inspeccion?.nombre ?? "-" }}
          </template>

          <template #cell(numero_sello)="row">
            {{ row.item?.inspectable?.numero_sello ?? "-" }}
          </template>

          <template #cell(estado)="row">
            <div
              class="flex flex-row items-center gap-2 text-white justify-center text-center px-2 py-1 cursor-pointer hover:brightness-110 hover:scale-105 transition-all"
              @click="
                () => {
                  selectedAforo = row.item;
                  showEditStatus = true;
                }
              "
              :class="[getVariant(row.item.estado)]"
            >
              {{ row.item?.estado ?? "-" }}
            </div>
          </template>

          <template #cell(acciones)="row">
            <div class="flex flex-col items-center gap-4 justify-center px-2">
              <div class="flex flex-row items-center gap-2">
                <button
                  class="btn-extra-primario"
                  @click="
                    () => {
                      selectedAforo = row.item;
                      showDeleteModal = true;
                    }
                  "
                >
                  <fas :icon="['fas', 'trash']"></fas>
                  Eliminar
                </button>
                <button
                  class="btn-extra-primario"
                  @click="
                    () =>
                      $router.push({
                        name: 'aforo-editar',
                        params: {
                          despachoId: row.item.despacho_id,
                          aforoId: row.item.id,
                        },
                      })
                  "
                >
                  <fas :icon="['fas', 'pen']"></fas>
                  Editar
                </button>
                <button
                  class="btn-extra-primario"
                  @click="
                    () =>
                      $router.push({
                        name: 'aforo-detalle',
                        params: {
                          despachoId: row.item.despacho_id,
                          aforoId: row.item.id,
                        },
                      })
                  "
                >
                  <fas :icon="['fas', 'eye']"></fas>
                  Ver aforo
                </button>
              </div>
            </div>
          </template>
        </b-table>

        <b-pagination
          v-if="pageMeta"
          v-model="pageMeta.current_page"
          style="width: 100px; margin: auto"
          :total-rows="pageMeta.total"
          :per-page="pageMeta.per_page"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
    </div>

    <modal-form-edit-status-aforo
      v-if="selectedAforo"
      :visible="showEditStatus"
      :aforo="selectedAforo"
      @close-modal="() => (showEditStatus = false)"
      @refetch="() => fetch()"
    />

    <modal-form-delete-aforo
      v-if="selectedAforo"
      :visible="showDeleteModal"
      :aforo="selectedAforo"
      @close-modal="() => (showDeleteModal = false)"
      @refetch="() => fetch()"
    />
  </div>
</template>
